"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const react_use_1 = require("react-use");
const index_1 = require("./Toolbar/index");
const List_1 = require("./List");
exports.ContentImportPanelInner = ({ usePortal, onClose }) => {
    const ref = react_2.useRef(null);
    react_use_1.useClickAway(ref, e => {
        const hasIgnoreAbove = e.target.closest('.osmosys-select-box, .osmosys-select-box-menu, .osmosys-select-box__indicator');
        if (hasIgnoreAbove) {
            return;
        }
        onClose();
    });
    const comp = (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.outer", bg: "white", borderLeft: true, shadow: "lg", className: "w-100 overflow-hidden", flexColFilled: true, innerRef: ref },
        react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.inner", flexColFilled: true, className: "overflow-hidden w-100" },
            react_2.default.createElement(index_1.ContentImportPanelToolbar, null),
            react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.body", flexColFilled: true, className: "overflow-y-auto w-100", padding: "sm" },
                react_2.default.createElement(List_1.ContentImportPanelContentList, null)))));
    if (usePortal) {
        return (react_2.default.createElement(react_1.Portal, { elementID: "emailCanvas-sidebar-portal", hideOverflow: true, mode: "replace" }, comp));
    }
    return comp;
};
//# sourceMappingURL=Inner.js.map